import axiosApi from '../../axios/axios-api'

const state = {
  llamadasRecepcion: []
}
const mutations = {
  setLlamadasRecepcion: (state, payload) => {
    state.llamadasRecepcion = payload
  }
}
const actions = {
  setLlamadasRecepcion: ({ commit }, payload) => {
    commit('setLlamadasRecepcion', payload)
  },
  fetchLlamadasRecepcion: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      axiosApi.get(`Llamadas/Recepcion?salaId=${data.salaId}&tipoLlamador=${data.tipoLlamador}`).then(response => {
        var responseData = response.data
        var list = responseData.data
        commit('setLlamadasRecepcion', list)
        resolve(list)
      })
    })
  },
  fetchLlamadasConsultorio: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      axiosApi.get(`Llamadas/Consultorio?salaId=${data.salaId}&tipoLlamador=${data.tipoLlamador}`).then(response => {
        var responseData = response.data
        var list = responseData.data
        commit('setLlamadasRecepcion', list)
        resolve(list)
      })
    })
  },
  llamarNumero: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      axiosApi.post('Llamadas', data)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response.data)
        })
    })
  },
  llamarSiguienteNumero: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      axiosApi.post('Llamadas/SiguienteNroRecepcion', data)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response.data)
        })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
